import { commitinfo } from './00_commitinfo_data.js';
import * as serviceworker from '@api.global/typedserver/web_serviceworker_client';
import * as domtools from '@design.estate/dees-domtools';

import { html, render } from '@design.estate/dees-element';
import { PhilkunzHeader } from './elements/header.js';
import { PhilkunzActionbar } from './elements/actionbar.js';
import { PhilkunzContent } from './elements/content.js';
import { PhilkunzCv } from './elements/cv.js';

import * as leleCatalog from '@losslessone_private/lele-catalog';
import * as socialIoCatalog from '@social.io_private/catalog';

const run = async () => {
  const domtoolsInstance = await domtools.DomTools.setupDomTools();
  domtoolsInstance.scroller.enableLenisScroll({
    disableOnNativeSmoothScroll: true
  });
  domtoolsInstance.themeManager.enableAutomaticGlobalThemeChange();
  const slogan = `simplifying life with Jazz, Love, Coffee and Code.`
  domtools.elementBasic.setup();
  domtoolsInstance.setWebsiteInfo({
    metaObject: {
      title: 'Phil Kunz - Jazz, Coffee, Tech and Love',
      description:
        `Phil Kunz is a European Entrepreneur focused on ${slogan}`,
      canonicalDomain: 'https://philkunz.com',
      ldCompany: {
        name: 'Lossless GmbH',
        status: 'active',
        contact: {
          address: {
            name: 'Lossless GmbH',
            city: 'Bremen',
            country: 'Germany',
            houseNumber: '16',
            postalCode: '28213',
            streetName: 'Ottilie-Hoffmann-Str.',
          },
          description: 'work',
          name: 'Lossless GmbH',
          type: 'company',
          facebookUrl: 'https://www.facebook.com/losslesscom',
          twitterUrl: 'https://twitter.com/losslesscom',
          website: 'https://lossless.com',
          phone: '+49 421 16767 548',
        },
        closedDate: null,
        foundedDate: {
          day: 1,
          month: 1,
          year: 2014,
        },
      },
    },
  });

  const serviceWorker = serviceworker.getServiceworkerClient();

  const mainTemplate = html`
    <style>
      body {
        margin: 0px;
        --background-accent: #303f9f;
      }

      lele-footer {
        border-top: 1px solid;
        border-image: radial-gradient(circle, #88888840, #88888800) 1;
      }
    </style>
    <lele-statusbar .siteText=${slogan} .commitinfo=${commitinfo} .commitinfos=${[commitinfo]}></lele-statusbar>
    <philkunz-header></philkunz-header>
    <philkunz-content></philkunz-content>
    <philkunz-actionbar></philkunz-actionbar>
    <lele-footer .commitinfo=${commitinfo}></lele-footer>
    <sio-fab style="position:fixed"></sio-fab>
  `;

  render(mainTemplate, document.body);
};

run();
